import {
  looksLikePlusDelimitedLabelScan,
  parseLabelScanElementString,
  resolveLabelScanManufacturerPartNumber,
} from "../../../../src/lib/gs1-element-string.js";

import type { InboundAmlLookupRow } from "./inboundApi";
import type { InboundLineRow } from "./inboundApi";

export function parseInboundSupplierLabelQuantity(raw: string): number | null {
  const parsed = parseLabelScanElementString(raw);
  if (parsed.quantity == null || parsed.quantity.trim() === "") {
    return null;
  }
  const quantity = Number.parseInt(parsed.quantity.trim(), 10);
  if (!Number.isFinite(quantity) || quantity <= 0) {
    return null;
  }
  return quantity;
}

export function resolveInboundSupplierLabelMpn(raw: string): string {
  return resolveLabelScanManufacturerPartNumber(raw);
}

export function inboundSupplierLabelMpnWasExtracted(raw: string): boolean {
  const mpn = resolveInboundSupplierLabelMpn(raw);
  if (mpn.trim() === "") {
    return false;
  }
  return looksLikePlusDelimitedLabelScan(raw) || mpn !== raw.trim();
}

export function pickInboundOrderLinesForLabelScan(
  lines: readonly Pick<InboundLineRow, "sku" | "source_item_id">[],
  amlRows: readonly Pick<InboundAmlLookupRow, "cpn">[],
): Pick<InboundLineRow, "sku" | "source_item_id">[] {
  const orderSkus = new Set(lines.map((line) => line.sku.trim().toLowerCase()));
  const matchingCpns = new Set(
    amlRows
      .map((row) => row.cpn.trim().toLowerCase())
      .filter((cpn) => orderSkus.has(cpn)),
  );
  return lines.filter((line) => matchingCpns.has(line.sku.trim().toLowerCase()));
}
